<template>
  <div id="app">
    <div v-if="!loading">
      <component :is="layout">
        <router-view :key="$route.fullPath" />
      </component>
    </div>

    <div v-else>
      <Loading />
    </div>
  </div>
</template>

<script>
const defaultLayout = "nonmember"
import Loading from "./components/Loading"
import VueCookies from "vue-cookies"
import firebase from "firebase/app"
import 'firebase/messaging'
import { mapState } from "vuex"
import { BModal, VBModal, BButton } from 'bootstrap-vue'
import { isLogin } from "@/js/commons/commons"
import ErrorDialog from '@/js/components/Common/ErrorDialog'
const autoCallSecond = 5000

export default {
  components: {
    Loading,
    BModal,
    BButton,
    ErrorDialog
  },
  directives: { BModal, VBModal, BButton },
  data() {
    return {
      timer: '',
      loading: true
    }
  },
  async mounted() {
    if (!this.$store.state.app.isSupportServiceWorker) {
      console.log("This browser doesn't support service workers")
    } else {
      const isSafari = /.*Version.*Safari.*/.test(navigator.userAgent)

      if (!isSafari) {
          firebase.initializeApp({
          apiKey           : `${process.env.MIX_API_KEY}`,
          authDomain       : `${process.env.MIX_AUTH_DOMAIN}`,
          projectId        : `${process.env.MIX_PROJECT_ID}`,
          messagingSenderId: `${process.env.MIX_MESSAGING_SENDER_ID}`,
          appId            : `${process.env.MIX_APP_ID}`,
          measurementId    : `${process.env.MIX_MEASUREMENT_ID}`,
        });

        const messaging = firebase.messaging();
        messaging.requestPermission();

        messaging.onMessage(payload => {
          navigator.serviceWorker
            .getRegistration("/firebase-cloud-messaging-push-scope")
            .then(registration => {
              let otpData = JSON.parse(payload.data.otp_data);
              registration.showNotification(payload.data.title, payload.data);
              if (otpData.accept_flg == 0) {
                this.$store.dispatch("otp/setOtpAccessToken", null);
                this.$bvModal.show('modal-error');
              } else {
                this.$store.dispatch(
                  "otp/setOtpAccessToken",
                  otpData.one_time_access_key
                );
              }
              this.$store.dispatch("otp/setOtpLoading", false);
              this.$bvModal.hide("otp-modal");
            });
        });

        await messaging
          .getToken()
          .then(currentToken => {
            if (currentToken) {
              this.$store.dispatch("auth/setFcmToken", currentToken);
            } else {
              console.error("No Instance ID token available. Request permission to generate one.");
            }
          })
          .catch(err => {
            console.log("An error occurred while retrieving token. ", err);
          });
      }
    }
    this.loading = false
  },
  computed: {
    layout() {
      if (this.$route.meta.layout === 'nothing') return "nothing-layout";
      const layout = isLogin() && this.$route.meta.layout !== 'pdf' && this.$route.meta.layout !== 'nonmember' ? 'member' : this.$route.meta.layout
      return (layout || defaultLayout) + "-layout"
    }
  },
  methods: {
    async checkStatusOTP() {
      console.log('Auto call check otp status')
      const params = {
        one_time_password: this.$store.state.otp.otpCode,
        dr_user_id: this.$store.state.auth.doctorInfo.id,
      }
      await this.$store.dispatch('otp/getStatusOTP', { params: params })

      if (this.$store.state.otp.statusOTP === 1) {
        clearInterval(this.timer)
        var currentPath = this.$router.currentRoute.path
        if (currentPath === '/patient') {
          location.reload()
        } else {
          this.$router.push('/patient')
        }
      } else if (this.$store.state.otp.statusOTP === 0) {
        clearInterval(this.timer)
        this.$bvModal.show('modal-error')
      }
    }
  },
  created() {
    if (!this.$store.state.auth.fcmToken) {
      if (this.$store.state.otp.otpLoading && !this.$store.state.otp.otpAccessToken) {
        this.timer = setInterval(this.checkStatusOTP, autoCallSecond)
      } else {
        clearInterval(this.timer)
      }
    }
  }
}
</script>
